import type { Todo, TodoFolder } from 'owa-todo-types';
import { today, now } from 'owa-datetime';

// ParentFolderId: Moving task across lists
export function getParentIdChangeOnMove(
    movedTodo: Todo,
    targetFolder: TodoFolder | undefined
): Partial<Todo> {
    if (movedTodo && targetFolder && targetFolder.Id !== movedTodo.ParentFolderId) {
        return { ParentFolderId: targetFolder.Id };
    }
    return {};
}

// Status: Moving task from completed items to active items
export function getStatusChangeOnMove(movedTodo: Todo): Partial<Todo> {
    if (movedTodo.CompletedDateTime !== null && movedTodo.Status !== 'NotStarted') {
        return { Status: 'NotStarted' };
    }
    return {};
}

// MyDay: Move task to or from MyDay list.
// If moveToMyDay is true, sets CommittedDay. If moveToMyDay is false, unsets CommittedDay.
export function getMyDayChangeOnMove(
    moveToMyDay: boolean,
    setCommittedOrder: boolean
): Partial<Todo> {
    let updatedProps = {};
    if (setCommittedOrder) {
        updatedProps = { CommittedOrder: now() };
    }
    if (moveToMyDay) {
        updatedProps = { ...updatedProps, CommittedDay: today(), PostponedDay: null };
    } else if (!moveToMyDay) {
        updatedProps = { ...updatedProps, CommittedDay: undefined, PostponedDay: today() };
    }
    return updatedProps;
}
